<template>
  <div>
    <div class="content">
      <v-sheet class="pb-4">
        <v-row>
          <v-col :align-self="$vuetify.breakpoint.smAndDown ? 'start' : 'center'"
                 align="center"
                 cols="12" lg="4" md="2" offset-lg="1">
            <fin-archetype-illustration :archetype="archetype"
                                        :height="$vuetify.breakpoint.smAndDown ? '80' : 180"
                                        :width="$vuetify.breakpoint.smAndDown ? '125' : 285"
                                        hide-animation
                                        hide-scene />
          </v-col>

          <v-col align="center" cols="12" lg="5" md="8">
            <p class="confirmation mb-6" style="text-align: center">{{ archetype.confirmationText }}</p>
            <p v-html="archetype.description"></p>
            <v-btn class="archetype-btn-agree mb-4" dark @click="confirmArchetypChoice()">
              <span>Ja, passt zu mir</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" lg="4" md="2" offset-lg="1"></v-col>
          <v-col cols="12" lg="5" md="8">
            <p style="font-weight: bold">Passt nicht ganz zu dir?</p>
            <p>Sieh dir auch die
              <v-btn class="archetype-btn-change pa-0" text @click="changeArchetypChoice()">
                <span class="text-btn">anderen Archetypen</span>
              </v-btn>
              an.
            </p>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col align="center" cols="12" lg="8" md="10" offset-lg="2">
            <p :style="'font-size: 12px; color:' + $finColors.coolGrey" class="my-0">
              <fin-lexicon-text auto-solve
                                text='Hinweis: Die Erstellung deines Portfolios nach der Ermittlung deines Archetyps ist eine einmalige Einschätzung aus der sich keine dauerhafte Geeignetheitsprüfung ableiten lässt. finCraft kann nicht garantieren, dass die gewählten Produkte auch in der Zukunft noch für dich geeignet sind.'/>
            </p>
          </v-col>
        </v-row>
      </v-sheet>
    </div>

  </div>
</template>

<script>
import FinArchetypeIllustration from '@/components/pages/onboarding/ArchetypeIllustration/index'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import AmplitudePush from "@/mixins/AmplitudePush"

export default {
  name: 'finArchetypeResult',
  mixins: [AmplitudePush],
  components: {FinArchetypeIllustration, FinLexiconText},
  props: {
    archetype: {}
  },
  data() {
    return {
      mode: undefined
    }
  },
  methods: {
    confirmArchetypChoice() {
      this.pushToAmplitude({
        'event': 'fincraft_' + this.mode + '_archetype_choice_confirmed',
        'step': this.mode + "_archetype_footer",
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$emit('archetypeOK')
    },
    changeArchetypChoice() {
      this.pushToAmplitude({
        'event': 'fincraft_' + this.mode + '_archetype_change_choice',
        'step': this.mode + "_archetype_start",
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.$emit('reset')
    }
  },
  mounted() {
    this.mode = this.$route.fullPath.includes('finProfiler') ? 'finProfiler' : 'onboarding'
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../styles/variables";

.text-btn {
  font-weight: normal;
  text-decoration: underline;
  font-size: 1.1em;
}

.text-btn:before {
  background-color: transparent;
}

.archetype-btn-change {
  height: auto !important;
  min-width: auto;
  vertical-align: text-top;
  line-height: 1.38;
}

.confirmation {
  font-family: $heading-font-family !important;
  font-size: 2.2em;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  line-height: 1.2;

  @media only screen and (max-width: 960px) {
    font-size: 1.8em;
  }
  @media only screen and (max-width: 600px) {
    font-size: 1.4em;
  }
}
</style>
